import React, { useState } from 'react';
import './AdvertisePopup.css';

const AdvertisePopup = () => {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <div className={`advertise-popup ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <button 
                className="popup-toggle"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-label={isExpanded ? 'Collapse' : 'Expand'}
            >
                <span className={`caret ${isExpanded ? 'down' : 'up'}`}>▼</span>
            </button>
            <a 
                href="https://advertise.bidderiq.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="popup-content"
            >
                <h3>Advertise on Bidder iQ</h3>
                <p>Reach thousands of Porsche collectors</p>
            </a>
        </div>
    );
};

export default AdvertisePopup;
